import { useCallback, useRef } from 'react'

import { useQueryClient } from 'react-query'

import { useBuildingContext } from '../../../contexts/buildingContext'

import { withPendingReviewTaskCount } from './reviewTaskFormat'

export const usePendingReviewTaskCount = () => {
  const queryClient = useQueryClient()
  const { state: buildingState, updateBuilding } = useBuildingContext()
  const projectDataRef = useRef(buildingState.projectData)
  projectDataRef.current = buildingState.projectData

  const setPendingReviewTaskCount = useCallback(
    (count: number) => {
      const next = Math.max(0, Number(count) || 0)
      updateBuilding({
        projectData: withPendingReviewTaskCount(projectDataRef.current, next),
      })
      const projectId = buildingState.projectId
      if (!projectId) {
        return
      }
      queryClient.setQueriesData(['building', projectId], (old: unknown) => {
        if (!old || typeof old !== 'object') {
          return old
        }
        return {
          ...(old as Record<string, unknown>),
          pending_review_task_count: next,
        }
      })
    },
    [buildingState.projectId, queryClient, updateBuilding],
  )

  const adjustPendingReviewTaskCount = useCallback(
    (delta: number) => {
      const current =
        Number(projectDataRef.current?.pending_review_task_count) || 0
      setPendingReviewTaskCount(current + delta)
    },
    [setPendingReviewTaskCount],
  )

  return { setPendingReviewTaskCount, adjustPendingReviewTaskCount }
}
